<template>
    <transition mode="out-in" name="fade-grow">
        <div v-if="showPrompt" class="sign-up-prompt">Yo dawg, you should sign up so your work is saved.</div>
    </transition>
</template>

<script>
    import SignUpPrompt from "../../Data/Store/SignUpPrompt";

    export default {
        name: "SignUpPrompt",

        props: {},

        computed: {
            showPrompt() {
                return new SignUpPrompt().getShowPrompt();
            }
        },

        data() {
            return {};
        },

        methods: {},
    }
</script>

<style scoped lang="scss">

</style>
